import {
  ON_GEL_UPDATE,
  ON_GEL_SELECT,
  ON_SUBMIT,
  ON_RESET,
  CLOSE_FEEDBACK
} from '../Redux.constants';

export const onGelSubmit = (params) => ({
  type: ON_SUBMIT,
  payload: params,
});

export const onGelReset = (params) => ({
  type: ON_RESET,
  payload: params,
});

export const onCloseFeedback = (params) => ({
  type: CLOSE_FEEDBACK,
  payload: params,
});

export const onGelUpdate = (params) => ({
  type: ON_GEL_UPDATE,
  payload: params,
});

export const onGelSelect = (params) => ({
  type: ON_GEL_SELECT,
  payload: params,
});
